(function () {
  var GAP = 35;
  var MOBILE_GAP = 44;
  var MAX_MOBILE_SLIDE = 594;

  // Tracks slides currently being synced to prevent infinite MutationObserver loops
  var syncingSet = new WeakSet();
  var emptyStateTimerMap = new WeakMap();
  var emptyStateMissMap = new WeakMap();
  var desktopIndexMap = new WeakMap();
  var arrowIntentMap = new WeakMap();
  var glamNavAlignRafMap = new WeakMap();

  function alignGlamNavToMedia(section) {
    if (!section) return;

    var nav = section.querySelector('.glam-in-action__nav, .glide__arrows');
    if (!nav) return;

    var inset = window.innerWidth <= 380 ? 18 : 22;
    section.style.setProperty('--glam-nav-inset', inset + 'px');

    if (window.innerWidth > 767) {
      section.style.removeProperty('--glam-nav-top');
      return;
    }

    var activeMedia = section.querySelector('.glide__slide--active .vugc-media-image, .glide__slide--active .vugc-media-video, .glide__slide--active .vugc-media-card, .glide__slide--active .vugc-card-container');

    if (!activeMedia) {
      activeMedia = section.querySelector('.glide__slide:not(.glide__slide--clone) .vugc-media-image, .glide__slide:not(.glide__slide--clone) .vugc-media-video, .glide__slide:not(.glide__slide--clone) .vugc-media-card, .glide__slide:not(.glide__slide--clone) .vugc-card-container');
    }

    if (!activeMedia) return;

    var parent = section.querySelector('.glide') || nav.offsetParent || section;
    if (!parent) return;

    var mediaRect = activeMedia.getBoundingClientRect();
    var parentRect = parent.getBoundingClientRect();
    var prevBtn = nav.querySelector('.bestsellers-slider__btn--prev, .glide__arrow--left');
    var btnRect = prevBtn ? prevBtn.getBoundingClientRect() : null;
    var buttonHalf = btnRect && btnRect.width ? btnRect.width / 2 : 16;
    var centerTop = mediaRect.top - parentRect.top + mediaRect.height / 2;
    var left = mediaRect.left - parentRect.left - buttonHalf;
    var right = parentRect.right - mediaRect.right - buttonHalf;

    if (!isFinite(centerTop)) return;

    section.style.setProperty('--glam-nav-top', Math.round(centerTop) + 'px');
    section.style.setProperty('--glam-nav-left', Math.round(left) + 'px');
    section.style.setProperty('--glam-nav-right', Math.round(right) + 'px');
  }

  function scheduleGlamNavAlign(section) {
    if (!section) return;
    if (glamNavAlignRafMap.has(section)) {
      cancelAnimationFrame(glamNavAlignRafMap.get(section));
    }
    var rafId = requestAnimationFrame(function () {
      alignGlamNavToMedia(section);
      glamNavAlignRafMap.delete(section);
    });
    glamNavAlignRafMap.set(section, rafId);
  }

  function getCurrentIndexFromTransform(slidesEl, step) {
    var match = (slidesEl.style.transform || '').match(/translate3d\((-?[\d.]+)px/);
    if (!match || !(step > 0)) return null;
    return Math.round(parseFloat(match[1]) / step);
  }

  function ensureTrackTransition(slidesEl) {
    var duration = slidesEl.style.transitionDuration;
    if (!duration || duration === '0s' || duration === '0ms') {
      slidesEl.style.transitionProperty = 'transform';
      slidesEl.style.transitionDuration = '400ms';
      slidesEl.style.transitionTimingFunction = 'ease';
    }
  }

  function getPerView() {
    if (window.innerWidth <= 750) return 1;
    if (window.innerWidth <= 989) return 2;
    return 4;
  }

  function updateSection(section) {
    var galleryWidget = section.querySelector('#yotpo-vugc-media-gallery-widget');
    if (galleryWidget) galleryWidget.style.width = '100%';

    var glide = section.querySelector('.glide, .yotpo-carousel, .yotpo-vugc-carousel-container');
    if (!glide) return false;

    var width = glide.clientWidth;
    var perView = getPerView();
    var gap = perView === 1 ? MOBILE_GAP : GAP;
    var slideWidth = Math.floor((width - gap * (perView - 1)) / perView);

    // On mobile (1 per view) cap at design width.
    if (perView === 1) slideWidth = Math.min(slideWidth, MAX_MOBILE_SLIDE);

    if (slideWidth <= 0) return false;

    section.style.setProperty('--glam-slide-w', slideWidth + 'px');
    section.style.setProperty('--glam-gap', gap + 'px');
    section.style.setProperty('--glam-per-view', perView);
    return true;
  }

  /**
   * Rescales Yotpo/Glide's inline transform and track width to match our forced
   * slide dimensions. Yotpo computes positions based on its own ~156px slide step;
   * we scale both values so the visual 309px cards align correctly.
   */
  function syncSlides(section, slidesEl) {
    if (syncingSet.has(slidesEl)) return;

    var allSlides = slidesEl.querySelectorAll('.glide__slide');
    if (!allSlides.length) return;

    var ourSlideW = parseFloat(section.style.getPropertyValue('--glam-slide-w')) || 309;
    var ourGap = parseFloat(section.style.getPropertyValue('--glam-gap')) || 35;
    var perView = parseFloat(section.style.getPropertyValue('--glam-per-view')) || 4;
    var ourStep = ourSlideW + ourGap;

    // Some products hydrate with different inline slide geometry (e.g. 180px + 8px gaps).
    // Normalize every slide inline so layout is consistent even if CSS arrives late.
    allSlides.forEach(function (slide) {
      slide.style.width = ourSlideW + 'px';
      slide.style.marginLeft = '0px';
      slide.style.marginRight = ourGap + 'px';
    });

    // Mobile: snap directly to the active slide's real offset to avoid half/merged frames.
    if (perView === 1) {
      var trackEl = slidesEl.parentElement; // .glide__track
      var titleEl = section.querySelector('.glam-in-action__title');
      if (trackEl) {
        var glideEl = trackEl.closest('.glide') || section.querySelector('.glide');
        var viewportW = glideEl ? glideEl.clientWidth : (ourSlideW + MOBILE_GAP);
        var insetLeft = Math.max(Math.round((viewportW - ourSlideW) / 2), 0);
        var trackVisibleW = Math.max(viewportW - insetLeft, ourSlideW);

        // Keep title aligned with the visual start of the active card in mobile.
        if (titleEl) {
          titleEl.style.paddingLeft = insetLeft + 'px';
          titleEl.style.paddingRight = '0px';
        }

        // Keep active card centered and force the visible window to end at right edge.
        trackEl.style.width = trackVisibleW + 'px';
        trackEl.style.maxWidth = 'none';
        trackEl.style.marginLeft = insetLeft + 'px';
        trackEl.style.marginRight = '0';
        trackEl.style.overflow = 'hidden';
      }

      var activeSlide = slidesEl.querySelector('.glide__slide--active');
      if (activeSlide) {
        var activeOffset = Math.round(activeSlide.offsetLeft);
        var mobileTransform = 'translate3d(' + (-activeOffset) + 'px, 0px, 0px)';
        var mobileWidth = (allSlides.length * ourStep).toFixed(2) + 'px';

        syncingSet.add(slidesEl);
        slidesEl.style.transform = mobileTransform;
        slidesEl.style.width = mobileWidth;
        Promise.resolve().then(function () { syncingSet.delete(slidesEl); });
      }
      scheduleGlamNavAlign(section);
      return;
    }

    var titleResetEl = section.querySelector('.glam-in-action__title');
    if (titleResetEl) {
      titleResetEl.style.removeProperty('padding-left');
      titleResetEl.style.removeProperty('padding-right');
    }

    // yotpoWidth is the total track width Yotpo set inline ("width: Xpx")
    var yotpoWidth = parseFloat(slidesEl.style.width);
    if (!(yotpoWidth > 0)) return;

    var yotpoStep = yotpoWidth / allSlides.length;
    if (!(yotpoStep > 0)) return;

    // Extract the translate3d X value Yotpo applied
    var match = (slidesEl.style.transform || '').match(/translate3d\((-?[\d.]+)px/);
    if (!match) return;

    // Convert Yotpo's offset to an index. When arrows are pressed, force one-step moves.
    var yotpoIndex = Math.round(parseFloat(match[1]) / yotpoStep);
    var currentIndex = desktopIndexMap.has(slidesEl) ? desktopIndexMap.get(slidesEl) : getCurrentIndexFromTransform(slidesEl, ourStep);
    var index = currentIndex == null ? yotpoIndex : currentIndex;
    var pendingIntent = arrowIntentMap.get(slidesEl) || 0;

    if (pendingIntent !== 0) {
      ensureTrackTransition(slidesEl);

      var direction = pendingIntent > 0 ? 1 : -1;
      index += direction;

      pendingIntent -= direction;
      if (pendingIntent === 0) {
        arrowIntentMap.delete(slidesEl);
      } else {
        arrowIntentMap.set(slidesEl, pendingIntent);
      }
    } else if (currentIndex == null) {
      // Before we have an internal index, take Yotpo's position once as the baseline.
      index = yotpoIndex;
    }

    desktopIndexMap.set(slidesEl, index);

    var newTransform = 'translate3d(' + (index * ourStep).toFixed(2) + 'px, 0px, 0px)';
    var newWidth = (allSlides.length * ourStep).toFixed(2) + 'px';

    // Guard against re-entry: the two style writes below will fire the observer again.
    // We mark the element as syncing; Promise.resolve() clears the flag after microtasks.
    syncingSet.add(slidesEl);
    slidesEl.style.transform = newTransform;
    slidesEl.style.width = newWidth;
    Promise.resolve().then(function () { syncingSet.delete(slidesEl); });
    scheduleGlamNavAlign(section);
  }

  /**
   * Yotpo sets background-image on .vugc-media-video at the small width it computed
   * (~156px). We intercept those inline style mutations and rewrite the CDN URL to
   * request an image matching our actual display width.
   */
  function fixVideoThumbnail(el, targetW) {
    var style = el.getAttribute('style') || '';
    var updated = style.replace(/url\(["']?([^"')]+)["']?\)/g, function (match, url) {
      var newUrl = url
        // Kaltura & Instagram CDN path segments: /width/NNN/height/NNN/
        .replace(/\/width\/[\d.]+\/height\/[\d.]+\//, '/width/' + targetW + '/height/' + targetW + '/')
        // Kaltura sprite sheet: vid_slices/N → request a single frame
        .replace(/\/vid_slices\/\d+\//, '/vid_slices/1/')
        // Cloudinary path param: /w_156/ or ,w_156,
        .replace(/(\/w_)\d+(\/|,)/, '$1' + targetW + '$2')
        // query-string: ?w=156 or &w=156 or ?width=156 or &width=156
        .replace(/([?&](?:width|w)=)\d+/, '$1' + targetW)
        // Yotpo /156x/ or /156x312/
        .replace(/\/\d+x\d*(\/|$)/, '/' + targetW + 'x$1');
      return newUrl !== url ? 'url("' + newUrl + '")' : match;
    });
    if (updated !== style) el.setAttribute('style', updated);
  }

  function bindVideoThumbnailObserver(section, targetW) {
    // Fix any thumbnails already in the DOM
    section.querySelectorAll('.vugc-media-video').forEach(function (el) {
      fixVideoThumbnail(el, targetW);
    });

    // Watch for Yotpo setting/updating background-image on future video elements
    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' && m.target.classList.contains('vugc-media-video')) {
          fixVideoThumbnail(m.target, targetW);
        }
        if (m.type === 'childList') {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('vugc-media-video')) {
              fixVideoThumbnail(node, targetW);
            }
            node.querySelectorAll && node.querySelectorAll('.vugc-media-video').forEach(function (el) {
              fixVideoThumbnail(el, targetW);
            });
          });
        }
      });
    }).observe(section, { attributes: true, attributeFilter: ['style'], subtree: true, childList: true });
  }

  function bindPlayIconGuard(section) {
    function getPlayIconFromTarget(target) {
      if (!target || !target.closest) return null;
      return target.closest('.vugc-media-card-icon-video');
    }

    function getCardFromIcon(icon) {
      if (!icon || !icon.closest) return null;
      return icon.closest('.vugc-card-container, .vugc-media-card');
    }

    section.addEventListener('pointerdown', function (event) {
      var icon = getPlayIconFromTarget(event.target);
      if (!icon) return;
      event.preventDefault();
      event.stopPropagation();
    }, true);

    section.addEventListener('touchstart', function (event) {
      var icon = getPlayIconFromTarget(event.target);
      if (!icon) return;
      event.preventDefault();
      event.stopPropagation();
    }, { capture: true, passive: false });

    section.addEventListener('click', function (event) {
      var icon = getPlayIconFromTarget(event.target);
      if (!icon) return;

      var card = getCardFromIcon(icon);
      if (!card) return;

      event.preventDefault();
      event.stopPropagation();
      card.click();
    }, true);
  }

  function bindArrowIntent(section, slidesEl) {
    section.addEventListener('click', function (event) {
      var rightArrow = event.target.closest('.glide__arrow--right, .yotpo-carousel-arrow.glide__arrow--right');
      var leftArrow = event.target.closest('.glide__arrow--left, .yotpo-carousel-arrow.glide__arrow--left');

      if (rightArrow) {
        arrowIntentMap.set(slidesEl, (arrowIntentMap.get(slidesEl) || 0) - 1);
        return;
      }

      if (leftArrow) {
        arrowIntentMap.set(slidesEl, (arrowIntentMap.get(slidesEl) || 0) + 1);
      }
    }, true);
  }

  function bindObserver(section) {
    var slidesEl = section.querySelector('.glide__slides');
    if (!slidesEl) return false;

    bindArrowIntent(section, slidesEl);

    new MutationObserver(function () {
      syncSlides(section, slidesEl);
    }).observe(slidesEl, { attributes: true, attributeFilter: ['style'] });

    // Apply immediately in case Yotpo already rendered
    syncSlides(section, slidesEl);

    // Fix video thumbnail resolution (2× DPR, cap at 800px)
    var ourSlideW = parseFloat(section.style.getPropertyValue('--glam-slide-w')) || 309;
    var targetW = Math.min(Math.round(ourSlideW * (window.devicePixelRatio || 1)), 800);
    bindVideoThumbnailObserver(section, targetW);

    bindBestsellersArrowSwap(section);

    return true;
  }

  /**
   * Replaces Yotpo's Glide arrows with the bestsellers nav component
   * (same SVG + classes used by master-the-look via slider-nav-bestsellers.css).
   * Yotpo renders arrows asynchronously, so we observe the section until they appear.
   */
  function bindBestsellersArrowSwap(section) {
    var prevSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">' +
      '<path d="M41.679 21.089C41.679 32.46 32.461 41.678 21.09 41.678C9.718 41.678 0.5 32.46 0.5 21.089C0.5 9.71798 9.718 0.499977 21.09 0.499977C32.461 0.499977 41.679 9.71798 41.679 21.089Z" fill="white" stroke="#E98299"/>' +
      '<path d="M25.59 11.85L15.5 21.94L25.238 31.678" stroke="#E98299"/>' +
      '</svg>';
    var nextSvg = '<svg xmlns="http://www.w3.org/2000/svg" width="43" height="43" viewBox="0 0 43 43" fill="none">' +
      '<path d="M41.679 21.089C41.679 32.46 32.461 41.678 21.09 41.678C9.718 41.678 0.5 32.46 0.5 21.089C0.5 9.71798 9.718 0.499977 21.09 0.499977C32.461 0.499977 41.679 9.71798 41.679 21.089Z" fill="white" stroke="#E98299"/>' +
      '<path d="M17.09 11.85L27.18 21.94L17.44 31.678" stroke="#E98299"/>' +
      '</svg>';

    function tryInject() {
      var wrap = section.querySelector('.glide__arrows');
      if (!wrap) return false;
      var prev = wrap.querySelector('.glide__arrow--left');
      var next = wrap.querySelector('.glide__arrow--right');
      if (!prev || !next) return false;

      if (!wrap.classList.contains('bestsellers-slider__nav')) {
        wrap.classList.add('bestsellers-slider__nav');
      }
      if (!wrap.classList.contains('glam-in-action__nav')) {
        wrap.classList.add('glam-in-action__nav');
      }
      if (!prev.dataset.bestsellersInjected) {
        prev.classList.add('bestsellers-slider__btn', 'bestsellers-slider__btn--prev');
        prev.innerHTML = prevSvg;
        prev.dataset.bestsellersInjected = '1';
      }
      if (!next.dataset.bestsellersInjected) {
        next.classList.add('bestsellers-slider__btn', 'bestsellers-slider__btn--next');
        next.innerHTML = nextSvg;
        next.dataset.bestsellersInjected = '1';
      }
      scheduleGlamNavAlign(section);
      return true;
    }

    if (tryInject()) return;

    var observer = new MutationObserver(function () {
      if (tryInject()) observer.disconnect();
    });
    observer.observe(section, { childList: true, subtree: true });

    section.addEventListener('click', function (event) {
      if (!event.target.closest('.glide__arrow--left, .glide__arrow--right, .yotpo-carousel-arrow')) return;
      setTimeout(function () {
        scheduleGlamNavAlign(section);
      }, 120);
    }, true);
  }

  function hasRenderableSlides(section) {
    return section.querySelectorAll('.glide__slide:not(.glide__slide--clone)').length > 0;
  }

  function isYotpoLoaded(section) {
    var loadedNode = section.querySelector('[data-yotpo-element-loaded]');
    return !!(loadedNode && loadedNode.getAttribute('data-yotpo-element-loaded') === 'true');
  }

  function syncEmptyStateVisibility(section) {
    if (hasRenderableSlides(section)) {
      emptyStateMissMap.set(section, 0);
      section.style.removeProperty('display');
      section.removeAttribute('aria-hidden');
      return;
    }

    if (!isYotpoLoaded(section)) return;

    // Hide only after several consecutive misses to avoid hydration race conditions.
    var misses = (emptyStateMissMap.get(section) || 0) + 1;
    emptyStateMissMap.set(section, misses);
    if (misses >= 3) {
      section.style.display = 'none';
      section.setAttribute('aria-hidden', 'true');
    }
  }

  function scheduleEmptyStateCheck(section, delay) {
    var prev = emptyStateTimerMap.get(section);
    if (prev) window.clearTimeout(prev);

    var timerId = window.setTimeout(function () {
      syncEmptyStateVisibility(section);
      emptyStateTimerMap.delete(section);

      // Keep sampling while loaded+empty until it is either hidden or hydrated with items.
      if (isYotpoLoaded(section) && !hasRenderableSlides(section) && section.style.display !== 'none') {
        scheduleEmptyStateCheck(section, 220);
      }
    }, delay || 250);

    emptyStateTimerMap.set(section, timerId);
  }

  function initSection(section) {
    if (!section || section.dataset.glamReady === 'true') return;
    section.dataset.glamReady = 'true';

    bindPlayIconGuard(section);

    var retries = 0;
    var bound = false;

    var timer = window.setInterval(function () {
      retries += 1;
      if (updateSection(section) && !bound) {
        bound = bindObserver(section);
      }
      scheduleGlamNavAlign(section);
      if (bound || retries >= 30) {
        window.clearInterval(timer);

        // One final fallback check in case no mutation is fired after load completes.
        scheduleEmptyStateCheck(section, 500);
      }
    }, 300);

    // React quickly when Yotpo hydrates or mutates the section.
    new MutationObserver(function () {
      scheduleEmptyStateCheck(section, 200);
    }).observe(section, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-yotpo-element-loaded']
    });

    if (window.ResizeObserver) {
      new ResizeObserver(function () {
        if (updateSection(section)) {
          var slidesEl = section.querySelector('.glide__slides');
          if (slidesEl) syncSlides(section, slidesEl);
        }
        scheduleGlamNavAlign(section);
      }).observe(section);
    }

    window.addEventListener('resize', function () {
      updateSection(section);
      scheduleGlamNavAlign(section);
    });
  }

  function init() {
    document.querySelectorAll('.glam-in-action').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
